import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import {
  getBillingTokenUsage,
  getBillingUserLimits,
  getBillingSubscriptionStatus,
  getBillingPlans,
  getBillingPaymentMethod,
} from "../api/BillingApi";

const api = {
  [ActionTypes.getBillingTokenUsage]: (projectId) => getBillingTokenUsage(projectId),
  [ActionTypes.getBillingUserLimits]: () => getBillingUserLimits(),
  [ActionTypes.getBillingSubscriptionStatus]: () => getBillingSubscriptionStatus(),
  [ActionTypes.getBillingPlans]: () => getBillingPlans(),
  [ActionTypes.getBillingPaymentMethod]: () => getBillingPaymentMethod(),
  [ActionTypes.setCheckoutSession]: (data) => ({ data }),
  [ActionTypes.showSelectPlanDialog]: () => ({}),
  [ActionTypes.hideSelectPlanDialog]: () => ({}),
  [ActionTypes.showUpgradePlanDialog]: (data) => ({ data }),
  [ActionTypes.hideUpgradePlanDialog]: () => ({}),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
